import { useState, useEffect } from 'react';
import './LoginForm.css'
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/card';
import { FcGoogle } from "react-icons/fc";
import axios from "axios";
import { toast } from 'sonner';
import { auth, googleProvider } from "@/Services/firebase";
import { IoMdArrowBack } from "react-icons/io";
import { OrbitProgress } from "react-loading-indicators";
import { useNavigate } from 'react-router-dom';
import { Mail, PlugZap, Space, ArrowLeft } from 'lucide-react';
import { decodeWithBase64, encodeWithBase64 } from '@/Services/encodedecode';
import { saveData } from '@/Services/Data';
import { fetchBridgeLanguageStrings, getBridgeLanguages } from '@/Services/Service';
import { LLServerID, LLServerIP } from '@/Services/Server';
import { signInWithPopup } from "firebase/auth";

// const LLServerIP = "http://192.168.1.115:8084/";
// const LLServerID = "6c42a301-221e-5953-ba10-32ac39680233"

// const LLServerIP = "https://ll.cosmitude.com/";
// const LLServerID = "f61eb7ea-3ff5-11e9-b210-d663bd873d93-085ac6ce-3ff6-11e9-b210-d663bd873d93"



export default function LoginForm({ setCurrentView, currentView }: { setCurrentView?: React.Dispatch<React.SetStateAction<'landing' | 'loginmcp' | 'loginagent' | 'dashboard'>>; currentView?: 'landing' | 'loginmcp' | 'loginagent' | 'dashboard' }) {
  type FormErrors = {
    email?: string;
    password?: string;
    emailidverification?: string;
    linkfirstname?: string;
    linklastname?: string;
    linkemail?: string;
    linkpassword?: string;
    verificationcode?: string;
    passwordemailidverification?: string;
    passwordVerificationOtp?: string;
    newpassword?: string;
    confirmnewpassword?: string;
  };
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [errors, setErrors] = useState<FormErrors>({});
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [emailidverification, setEmailIDVerification] = useState<string>("");
  const [setloading, setIsLoading] = useState(false);
  const [createaccount, SetCreateAccount] = useState(false);
  const [emailpassword, setEmailpassword] = useState(true);
  const [passwordverifi, setPasswordverifi] = useState(false);
  const [linkcreateaccount, setLinkCreateaccount] = useState(false);
  const [linkemail, setLinkEmail] = useState<string>("");
  const [verificationcode, setVerificationCode] = useState<string>("");
  const [linkpassword, setlinkPassword] = useState<string>("");
  const [linkfirstName, setlinkfirstName] = useState<string>("");
  const [linklastName, setlinklastName] = useState<string>("");
  const [passwordemailidverification, setPasswordEmailIDVerification] = useState<string>("");
  const [passwordreset, setPasswordreset] = useState(false);
  const [passwordVerificationOtp, setPasswordVerificationOtp] = useState<string>("");
  const [newpassword, setNewPassword] = useState<string>("");
  const [confirmnewpassword, setConfirmNewPassword] = useState<string>("");

  useEffect(() => {
    checkForPreviousLogin();
  }, [])

  const checkForPreviousLogin = async () => {
    try {
      let userProfile = localStorage.getItem("userProfile");
      if (userProfile) {
        userProfile = JSON.parse(decodeWithBase64(userProfile));
        sessionStorage.setItem("IsNewlogin", "true");
        if (currentView === 'loginmcp') {
          navigate("/mcpOrchestrator");
        }
        if (currentView === 'loginagent') {
          navigate("/dashboard");
        }
      }
    } catch (e) {
      return;
    }
  }

  const validate = () => {
    const next: FormErrors = {};
    if (!email) {
      next.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      next.email = "Enter a valid email";
    }
    if (!password) {
      next.password = "Password is required";
    } else if (password.length < 6) {
      next.password = "Minimum 6 characters";
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const googleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const emailID = user.email;
      if (!emailID) return;
      const tokenID = await user.getIdToken();
      const loginJson = {
        UserName: emailID,
        LoginToken: tokenID,
      };
      sendWithTokenId(loginJson, user);
    } catch (error: any) {
      if (error.code === "auth/cancelled-popup-request") {
        console.warn("Google login canceled by the user.");
      } else {
        console.error("Google login error:", error.message);
      }
    }
  };
  const sendWithTokenId = async (loginJson, user) => {
    var firstName = user.displayName ? user.displayName : "John";
    var emailId = user.email;
    var aliasUUID = generateUUID(10);
    var userName = "@user" + aliasUUID;
    var lastName = "";
    let userNameData = {
      userName: userName,
      firstName: firstName,
      lastName: lastName,
    }
    let jsonObject = {
      "UserName": userName,
      "FirstName": firstName,
      "LastName": lastName,
      "MACAddress": "Bridge-Web",
      "UPI": "",
      "TokenID": "",
      "DefaultForumAcceptance": true,
      "SignInID": emailId,
      "ServerID": LLServerID,
      "LoginToken": loginJson['LoginToken'],
    }
    let payload = new FormData();
    setIsLoading(true);
    payload.append('Data', JSON.stringify(jsonObject));
    const data = await loginWithGoogle(payload);
    localStorage.setItem("BotLogin", 'false');
    loginCredentials(data, user, loginJson, userNameData);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await new Promise((r) => setTimeout(r, 800));
      let json = {
        "MACAddress": "Bridge-Web",
        "SignInID": email,
        "ServerID": LLServerID,
        "Password": password,
        "TokenID": ""
      }
      let result = await emailLogin(json)
      console.log(result)
      if (result['ErrorCode'] === 1069) {
        let data = result['ErrorMessage']['ErrorMessage']
        let userNameData = {
          userName: data.UserName,
          firstName: data.FirstName,
          lastName: data.LastName,
        }
        loginCredentials(result, '', { UserName: email }, userNameData)
      } else if (result['ErrorCode'] === 1072) {
        toast.warning(result['ErrorMessage'])
      } else if (result['ErrorCode'] === 1074) {
        toast.warning('Login Failed')
      } else if (result['ErrorCode'] === 1075) {
        toast.warning('Login Failed')
      }
    } finally {
      setLoading(false);
    }
  };
  const generateUUID = digits => {
    let str = '0123456789abcdefghijklmnopqrstuvwxyz';
    let uuid = [];
    for (let i = 0; i < digits; i++) {
      uuid.push(str[Math.floor(Math.random() * str.length)]);
    }
    return uuid.join('');
  };
  const loginCredentials = async (data, user, loginJson, userNameData) => {
    if (data['ErrorCode'] == 1069) {
      if (data['ErrorMessage']['ErrorCode'] === 1005) {
        let loginData = (data['ErrorMessage']['ErrorMessage']);
        let userData = {}
        userData['CountryCode'] = loginData['CountryCode'];
        userData['MobileNumber'] = loginData['MobileNumber'];
        userData['Language'] = loginData['Language'];
        userData['DarkMode'] = loginData['DarkMode'];
        userData['FirstName'] = loginData['FirstName'];
        userData['LastName'] = loginData['LastName'];
        userData['MACAddress'] = loginData['MACAddress'];
        userData['SessionID'] = loginData['SessionID'];
        userData['Password'] = loginData['Password'];
        userData['UserName'] = loginData['UserName'];
        userData['emailId'] = loginJson['UserName'];
        let countryCode = userData['CountryCode'];
        let mobileNum = userData['MobileNumber'];
        let concatNumber = countryCode + mobileNum;
        userData['MobileNumber'] = concatNumber;
        userData['CosmitudeAdmin'] = loginData['CosmitudeAdmin'];
        if (!userData["MACAddress"]) {
          userData["MACAddress"] = 'Bridge-Web'
        }
        localStorage.setItem("userProfile", (JSON.stringify(userData)));
        setIsLoading(false);
        await saveData("UserEmailId", encodeWithBase64(loginJson['UserName']));
        sessionStorage.setItem("IsNewlogin", "true");
        await storeLanguageStrings(loginJson['Language']);
        if (currentView === 'loginmcp') {
          navigate("/mcpOrchestrator");
        }
        if (currentView === 'loginagent') {
          navigate("/dashboard");
        }
      }
      else {
        toast.error("Something went wrong please try again later");
        setIsLoading(false);
      }
    }
    else if (data['ErrorCode'] === 1005) {
      let loginData = (data['ErrorMessage']);
      let userData = {}
      userData['CountryCode'] = loginData['CountryCode'];
      userData['MobileNumber'] = loginData['MobileNumber'];
      userData['SessionID'] = loginData['SessionID'];
      userData['FirstName'] = loginData['FirstName'];
      userData['LastName'] = loginData['LastName'];
      userData['MACAddress'] = loginData['MACAddress'];
      userData['Password'] = loginData['Password'];
      userData['UserName'] = loginData['UserName'];
      userData['emailId'] = loginJson['UserName'];
      let countryCode = userData['CountryCode'];
      let mobileNum = userData['MobileNumber'];
      let concatNumber = countryCode + mobileNum;
      userData['MobileNumber'] = concatNumber;
      if (!userData["MACAddress"]) {
        userData["MACAddress"] = 'Bridge-Web'
      }
      if (!userData['UserName']) {
        userData['UserName'] = userNameData['userName'];
      }
      if (!userData['FirstName']) {
        userData['FirstName'] = userNameData['firstName'];
      }
      if (!userData['LastName']) {
        userData['LastName'] = userNameData['lastName'];
      }
      localStorage.setItem("userProfile", (JSON.stringify(userData)));
      setIsLoading(false);
      await saveData("UserEmailId", encodeWithBase64(loginJson['UserName']));
      sessionStorage.setItem("IsNewlogin", "true");
      await storeLanguageStrings(loginJson['Language']);
      if (currentView === 'loginmcp') {
        navigate("/mcpOrchestrator");
      }
      if (currentView === 'loginagent') {
        navigate("/dashboard");
      }
    }
    else if (data['ErrorCode'] === 1074) {
      if (user != null) {
        let payload = new FormData();
        var firstName = user.displayName ? user.displayName : "John";
        var emailId = user.email;
        var phoneNumber = user.phoneNumber;
        if (emailId == null && phoneNumber != null) {
          emailId = phoneNumber;
        }
        var lastName = "";
        var aliasUUID = generateUUID(10);
        var userName = "@user" + aliasUUID;
        let jsonObject = {
          "UserName": userName,
          "FirstName": firstName,
          "LastName": lastName,
          "MACAddress": "Bridge-Web",
          "UPI": "",
          "TokenID": "",
          "DefaultForumAcceptance": true,
          "SignInID": emailId,
          "ServerID": LLServerID,
          "LoginToken": loginJson['LoginToken'],
        }
        payload.append('Data', JSON.stringify(jsonObject));
        const data = await loginWithGoogle(payload);
        if (data['ErrorCode'] === 1005) {
          let userData = (data['ErrorMessage']);
          let countryCode = userData['CountryCode'];
          let mobileNum = userData['MobileNumber'];
          let concatNumber = countryCode + mobileNum;
          userData['MobileNumber'] = concatNumber;
          userData['UserProfilePicture'] = user.photoURL;
          userData['emailId'] = loginJson['UserName'];
          if (!userData["MACAddress"]) {
            userData["MACAddress"] = 'Bridge-Web'
          }
          localStorage.setItem("userProfile", (JSON.stringify(userData)));
          setIsLoading(false);
          await saveData("UserEmailId", encodeWithBase64(loginJson['UserName']));
          // await fetchForumData(userData);
          await storeLanguageStrings(loginJson['Language']);
          sessionStorage.setItem("IsNewlogin", "true");
          if (currentView === 'loginmcp') {
            navigate("/mcpOrchestrator");
          }
          if (currentView === 'loginagent') {
            navigate("/dashboard");
          }
        }
        else {
          setIsLoading(false);
        }
      }
    }
  };
  const verifiemailvalidate = () => {
    const next: FormErrors = {};
    if (!emailidverification) next.emailidverification = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailidverification))
      next.emailidverification = "Enter a valid email";

    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const handleOpenAccountCreation = () => {
    setLinkCreateaccount(true);
    SetCreateAccount(false);
    setLinkEmail(emailidverification);
    setVerificationCode("");
    setlinkfirstName("");
    setlinklastName("");
    setlinkPassword("")
  }
  const handleEmailIDVerification = async () => {
    if (!verifiemailvalidate()) return;
    setIsLoading(true)
    let json = {
      "to": emailidverification,
      "ServerID": LLServerID,
      "WebLink": "https://bridge.cosmitude.com/",
      "LLServerLink": LLServerIP
    }
    let data = await emailAccountCreation(json)
    if (data['ErrorCode'] === 3333) {
      setIsLoading(false)
      toast.warning(data['ErrorMessage'])
    } else if (data['ErrorCode'] === 4444) {
      setIsLoading(false)
      toast.success(data['ErrorMessage'])
      handleOpenAccountCreation();
    } else if (data['ErrorCode'] === 4007) {
      setIsLoading(false)
      toast.success(data['ErrorMessage'])
      handleOpenAccountCreation();
    } else {
      setIsLoading(false);
    }
    console.log(data)
  };
  const handleSendPasswordLink = () => {
    setPasswordverifi(true)
    setEmailpassword(false)
  };
  const Linkvalidate = () => {
    const next: FormErrors = {};
    const NAME_RE = /^[\p{L}][\p{L}' -]{1,48}$/u;

    const fn = (linkfirstName || "").trim();
    if (!fn) next.linkfirstname = "First name is required";
    else if (fn.length < 2) next.linkfirstname = "Minimum 2 characters";
    else if (!NAME_RE.test(fn)) next.linkfirstname = "Only letters, spaces, - and '";

    const ln = (linklastName || "").trim();
    if (!ln) next.linklastname = "Last name is required";
    else if (ln.length < 2) next.linklastname = "Minimum 2 characters";
    else if (!NAME_RE.test(ln)) next.linklastname = "Only letters, spaces, - and '";

    const vc = (verificationcode || "").trim();
    if (!vc) next.verificationcode = "Verification code is required";

    if (!linkemail) next.linkemail = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(linkemail))
      next.linkemail = "Enter a valid email";

    if (!linkpassword) next.linkpassword = "Password is required";
    else if (linkpassword.length < 6) next.linkpassword = "Minimum 6 characters";
    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const onCreateaccountSubmit = async (e) => {
    e.preventDefault();
    if (!Linkvalidate()) return;
    setLoading(true);
    try {
      setIsLoading(true);
      var aliasUUID = generateUUID(10);
      var userName = "@user" + aliasUUID;
      let json = {
        "UserName": userName,
        "FirstName": linkfirstName,
        "LastName": linklastName,
        "MACAddress": "Bridge-Web",
        "UPI": "",
        "TokenID": "",
        "DefaultForumAcceptance": true,
        "SignInID": linkemail,
        "ServerID": LLServerID,
        "LoginToken": verificationcode,
        "Password": linkpassword
      }
      let payload = new FormData();
      payload.append('Data', JSON.stringify(json));
      let responce = await emailAccountVerification(payload, LLServerIP)
      if (responce['ErrorCode'] === 3333) {
        setIsLoading(false)
        toast.warning(responce['ErrorMessage']);
        setEmailpassword(true)
        setLinkCreateaccount(false)
        window.history.replaceState({}, "", "/");
      } else if (responce['ErrorCode'] === 1005) {
        setIsLoading(false)
        toast.success("Account Created Successfully, Please Login");
        setEmailpassword(true)
        setLinkCreateaccount(false)
        window.history.replaceState({}, "", "/");
      }
      else if (responce['ErrorCode'] === 4004) {
        setIsLoading(false)
        toast.error(responce['ErrorMessage']);
        setEmailpassword(true)
        setLinkCreateaccount(false)
        window.history.replaceState({}, "", "/");
      }
      else if (responce['ErrorCode'] === 4002) {
        setIsLoading(false)
        toast.error(responce['ErrorMessage']);
        setEmailpassword(true)
        setLinkCreateaccount(false)
        window.history.replaceState({}, "", "/");
      } else {
        setIsLoading(false)
        toast.warning('Something Went Wrong');
      }
      // }

    } finally {
      setLoading(false);
    }
  };
  const handleCreateAccount = () => {
    SetCreateAccount(true)
    setEmailpassword(false)
  };
  const verifipasswordemailvalidate = () => {
    const next: FormErrors = {};

    if (!passwordemailidverification) next.passwordemailidverification = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(passwordemailidverification))
      next.passwordemailidverification = "Enter a valid email";

    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const handleOpenPasswordReset = () => {
    setPasswordverifi(false);
    setPasswordreset(true);
    setPasswordVerificationOtp("");
    setNewPassword("");
    setConfirmNewPassword("");
  }
  const handlepasswordVerification = async () => {
    if (!verifipasswordemailvalidate()) return;
    setIsLoading(true)
    let json = {
      "to": passwordemailidverification,
      "ServerID": LLServerID,
      "WebLink": "https://bridge.cosmitude.com/",
      "LLServerLink": LLServerIP
    }
    let data = await emailAccountPasswordReset(json)
    if (data['ErrorCode'] === 4005) {
      setIsLoading(false)
      toast.warning(data['ErrorMessage'])
    } else if (data['ErrorCode'] === 4444) {
      setIsLoading(false)
      toast.warning(data['ErrorMessage'])
    } else if (data['ErrorCode'] === 4006) {
      setIsLoading(false)
      handleOpenPasswordReset();
      toast.success(data['ErrorMessage'])
    } else {
      setIsLoading(false)
    }
    console.log(data)
  };
  const resetpasswordvalidate = () => {
    const next: FormErrors = {};

    if (!newpassword) next.newpassword = "Password is required";
    else if (newpassword.length < 6) next.newpassword = "Minimum 6 characters";

    if (!confirmnewpassword) next.confirmnewpassword = "Confirm Password is required";
    else if (confirmnewpassword.length < 6) next.confirmnewpassword = "Minimum 6 characters";

    if (!passwordVerificationOtp) next.passwordVerificationOtp = "Verification code is required";
    else if (passwordVerificationOtp.length < 1) next.passwordVerificationOtp = "Verification code is required";
    setErrors(next);
    return Object.keys(next).length === 0;
  };
  const onResetPasswordSubmit = async (e) => {
    e.preventDefault();
    if (!resetpasswordvalidate()) return;
    if (!passwordemailidverification && passwordemailidverification !== "") return;
    setLoading(true);
    try {
      if (newpassword === confirmnewpassword) {
        setIsLoading(true)
        // let linkdata = isLoginModaldata
        // if (linkdata) {
        //   let data = linkdata
        let json = {
          "SignInID": passwordemailidverification,
          "LoginToken": passwordVerificationOtp,
          "Password": confirmnewpassword,
          "ServerID": LLServerID
        }
        let responce = await userNewPasswordUpdate(json, LLServerIP)
        if (responce['ErrorCode'] === 4004 || responce['ErrorCode'] === 4008 || responce['ErrorCode'] === 4002 || responce['ErrorCode'] === 4005) {
          setIsLoading(false)
          toast.error(responce['ErrorMessage']);
          window.history.replaceState({}, "", "/");
          setPasswordreset(false)
          setEmailpassword(true)
        } else if (responce['ErrorCode'] === 4009) {
          setIsLoading(false)
          toast.success(responce['ErrorMessage']);
          window.history.replaceState({}, "", "/");
          setPasswordreset(false)
          setEmailpassword(true)
        } else if (responce['ErrorCode'] === 4002 || responce['ErrorCode'] === 4005) {
          setIsLoading(false)
          toast.error(responce['ErrorMessage']);
          window.history.replaceState({}, "", "/");
          setPasswordreset(false)
          setEmailpassword(true)
        } else {
          setIsLoading(false)
        }
        console.log(responce)
        // }

      } else {
        toast.error('Both password should be same')
      }

    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    if (setCurrentView) {
      setCurrentView('landing');
    } else {
      navigate(-1);
    }
  }

  const storeLanguageStrings = async (language) => {
    try {
      let currentLanguage = 'English'
      if (language) {
        localStorage.setItem('language', language);
        currentLanguage = language;
      }
      else {
        localStorage.setItem('language', "English");
        currentLanguage = 'English'
      }
      const langData = await getBridgeLanguages();
      let langList = langData['Languages'];
      if (!langList || langList.length === 0) {
        langList = ['English'];
      }
      saveData('languageList', encodeWithBase64(JSON.stringify(langList)));
      const data = await fetchBridgeLanguageStrings(currentLanguage);
    } catch (error) {

    }
  }
  return (
    <div >
      <header className="fixed top-0 left-0 right-0 h-20 bg-white border-b border-gray-200 flex items-center px-6 z-20">
        <ArrowLeft onClick={handleClose} />
        <div className="flex items-center space-x-2 min-w-0 flex-1 overflow-hidden" style={{ marginLeft: 30 }}>
          {currentView === "loginmcp" ? (
            <><PlugZap className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />
              <span className="font-bold text-gray-900 whitespace-nowrap [font-size:clamp(0.85rem,4.2vw,1.5rem)]">
                MCP Orchestrator
              </span></>
          ) : (
            <div className="flex items-center space-x-2">
              <Mail className="h-8 w-8 text-blue-600" />
              <span className="text-2xl font-bold text-gray-900">Email Tracker</span>
            </div>
          )}
        </div>
      </header>
      {emailpassword ? (
        <Card className="w-full max-w-md p-8 shadow-xl border-border z-10 animate-slide-up">
          <div className="relative flex items-center w-full">
            <IoMdArrowBack className="absolute left-0 w-6 h-6 text-white cursor-pointer" />
            <h2 className="mx-auto text-center tittle">Login</h2>
          </div>
          <form onSubmit={onSubmit} noValidate>
            <div className="field">
              <label htmlFor="email" className="labelemail">Email</label>
              <input
                id="email"
                type="email"
                className={`input ${errors.email ? "input-error" : ""}`}
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                style={{ boxSizing: 'border-box' }}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div className="field">
              <label htmlFor="password" className="label">Password</label>
              <div className="password-wrap">
                <input
                  id="password"
                  type={showPass ? "text" : "password"}
                  className={`input ${errors.password ? "input-error" : ""}`}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  style={{ boxSizing: 'border-box' }}
                />
                <button
                  type="button"
                  className="toggle"
                  onClick={() => setShowPass((s) => !s)}
                  aria-label={showPass ? "Hide password" : "Show password"}
                >
                  {showPass ? "Hide" : "Show"}
                </button>
              </div>
              {errors.password && <p className="error">{errors.password}</p>}
            </div>
            <span
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: 12,
                color: 'grey',
                marginLeft: 0
              }}
            >
              By continuing, you agree to Cosmitude&apos;s{' '}

              <a
                href="https://cosmitude.com/#/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2563eb', textDecoration: 'none' }}
              >
                Terms of Use
              </a>

              {' '}and{' '}

              <a
                href="https://cosmitude.com/#/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2563eb', textDecoration: 'none' }}
              >
                Privacy Policy
              </a>
              .
            </span>

            <button className="btn" type="submit" disabled={loading} >
              {loading ? "Signing in..." : "Sign in"}
            </button>

            <div className="links">
              <span style={{ cursor: 'pointer' }} onClick={() => handleSendPasswordLink()}>Forgot password?</span>
              <span>·</span>
              <span style={{ cursor: 'pointer' }} onClick={() => handleCreateAccount()}>Create account</span>
            </div>
          </form>
          <h3 style={{ textAlign: 'center', marginTop: 10 }}>OR</h3>
          <Button className="AllButtons" style={{ backgroundColor: 'white', width: '100%', fontSize: "18px", fontWeight: '600', marginTop: 10, borderColor: 'black', borderWidth: 1, borderRadius: 5 }}
            onClick={googleLogin}>
            <FcGoogle style={{ width: 25, height: 25 }} />
            <span style={{ color: 'black' }}>Sign in using Google</span>
          </Button>
        </Card>
      ) : createaccount ? (
        <Card className="w-[440px] min-w-md p-8 shadow-xl border-border z-10 animate-slide-up">
          <div>
            <div className="relative flex items-center w-full">
              <IoMdArrowBack className="absolute left-0 w-6 h-6 text-black cursor-pointer" onClick={() => { setEmailpassword(true); SetCreateAccount(false) }} />
              <h2 className="mx-auto text-center tittle">Verify Email</h2>
            </div>
            <div className="field">
              <label htmlFor="email" className="labelemail">Email</label>
              <input
                id="email"
                type="email"
                className={`input ${errors.emailidverification ? "input-error" : ""}`}
                placeholder="you@example.com"
                value={emailidverification}
                onChange={(e) => setEmailIDVerification(e.target.value)}
                autoComplete="email"
                style={{ boxSizing: 'border-box' }}
              />
              {errors.emailidverification && <p className="error">{errors.emailidverification}</p>}
            </div>
            <button className="btn" type="submit" onClick={handleEmailIDVerification}>
              Verify Email
            </button>
          </div>
        </Card>
      ) : linkcreateaccount ? (
        <Card className="w-[440px] max-w-md p-8 shadow-xl border-border z-10 animate-slide-up">
          <div>
            <div className="relative flex items-center w-full">
              <IoMdArrowBack className="absolute left-0 w-6 h-6 text-black cursor-pointer" onClick={() => { setEmailpassword(true); setLinkCreateaccount(false) }} />
              <h2 className="mx-auto text-center tittle">Create Account</h2>
            </div>
            <form onSubmit={onCreateaccountSubmit} noValidate>
              <div className="field">
                <label htmlFor="email" className="labelemail">Email</label>
                <input
                  id="email"
                  type="email"
                  className={`input ${errors.linkemail ? "input-error" : ""}`}
                  placeholder="you@example.com"
                  value={linkemail}
                  disabled
                  onChange={(e) => setLinkEmail(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.linkemail && <p className="error">{errors.linkemail}</p>}
              </div>
              <div className="field">
                <label htmlFor="email" className="labelemail">Verification OTP</label>
                <input
                  id="email"
                  type="input"
                  className={`input ${errors.verificationcode ? "input-error" : ""}`}
                  value={verificationcode}
                  placeholder="Enter Verification OTP"
                  onChange={(e) => setVerificationCode(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.verificationcode && <p className="error">{errors.verificationcode}</p>}
              </div>
              <div className="field">
                <label htmlFor="email" className="labelemail">First Name</label>
                <input
                  id="email"
                  type="input"
                  className={`input ${errors.linkfirstname ? "input-error" : ""}`}
                  value={linkfirstName}
                  onChange={(e) => setlinkfirstName(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.linkfirstname && <p className="error">{errors.linkfirstname}</p>}
              </div>
              <div className="field">
                <label htmlFor="email" className="labelemail">Last Name</label>
                <input
                  id="email"
                  type="input"
                  className={`input ${errors.linklastname ? "input-error" : ""}`}
                  value={linklastName}
                  onChange={(e) => setlinklastName(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.linklastname && <p className="error">{errors.linklastname}</p>}
              </div>
              <div className="field">
                <label htmlFor="password" className="label">Password</label>
                <div className="password-wrap">
                  <input
                    id="password"
                    type={showPass ? "text" : "password"}
                    className={`input ${errors.linkpassword ? "input-error" : ""}`}
                    placeholder="••••••••"
                    value={linkpassword}
                    onChange={(e) => setlinkPassword(e.target.value)}
                    autoComplete="current-password"
                    style={{ boxSizing: 'border-box' }}
                  />
                  <button
                    type="button"
                    className="toggle"
                    onClick={() => setShowPass((s) => !s)}
                    aria-label={showPass ? "Hide password" : "Show password"}
                  >
                    {showPass ? "Hide" : "Show"}
                  </button>
                </div>
                {errors.linkpassword && <p className="error">{errors.linkpassword}</p>}
              </div>
              <button className="btn" type="submit" disabled={loading} >
                Create Account
              </button>
            </form>
          </div>
        </Card>
      ) : passwordverifi ? (
        <Card className="w-[440px] max-w-md p-8 shadow-xl border-border z-10 animate-slide-up">
          <div className="relative flex items-center w-full">
            <IoMdArrowBack className="absolute left-0 w-6 h-6 text-black cursor-pointer" onClick={() => { setEmailpassword(true); setPasswordverifi(false) }} />
            <h2 className="mx-auto text-center tittle">Reset Password</h2>
          </div>
          <div className="field">
            <label htmlFor="email" className="labelemail">Email</label>
            <input
              id="email"
              type="email"
              className={`input ${errors.passwordemailidverification ? "input-error" : ""}`}
              placeholder="you@example.com"
              value={passwordemailidverification}
              onChange={(e) => setPasswordEmailIDVerification(e.target.value)}
              autoComplete="email"
              style={{ boxSizing: 'border-box' }}
            />
            {errors.passwordemailidverification && <p className="error">{errors.passwordemailidverification}</p>}
          </div>
          <button className="btn" type="submit" onClick={handlepasswordVerification}>
            Request Password Reset
          </button>
        </Card>
      ) : passwordreset && (
        <Card className="w-[440px] max-w-md p-8 shadow-xl border-border z-10 animate-slide-up">
          <div>
            <div className="relative flex items-center w-full">
              <IoMdArrowBack className="absolute left-0 w-6 h-6 text-black cursor-pointer" onClick={() => { setEmailpassword(true); setPasswordreset(false) }} />
              <h2 className="mx-auto text-center tittle">Reset Password</h2>
            </div>
            <form onSubmit={onResetPasswordSubmit} noValidate>
              <div className="field">
                <label htmlFor="email" className="labelemail">New Password</label>
                <input
                  id="email"
                  type="input"
                  className={`input ${errors.newpassword ? "input-error" : ""}`}
                  value={newpassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.linkfirstname && <p className="error">{errors.linkfirstname}</p>}
              </div>
              <div className="field">
                <label htmlFor="password" className="label">Confirm New Password</label>
                <div className="password-wrap">
                  <input
                    id="password"
                    type={showPass ? "text" : "password"}
                    className={`input ${errors.confirmnewpassword ? "input-error" : ""}`}
                    placeholder="••••••••"
                    value={confirmnewpassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    autoComplete="current-password"
                    style={{ boxSizing: 'border-box' }}
                  />
                  <button
                    type="button"
                    className="toggle"
                    onClick={() => setShowPass((s) => !s)}
                    aria-label={showPass ? "Hide password" : "Show password"}
                  >
                    {showPass ? "Hide" : "Show"}
                  </button>
                </div>
                {errors.confirmnewpassword && <p className="error">{errors.confirmnewpassword}</p>}
              </div>
              <div className="field">
                <label htmlFor="email" className="labelemail">Verification OTP</label>
                <input
                  id="email"
                  type="input"
                  className={`input ${errors.passwordVerificationOtp ? "input-error" : ""}`}
                  value={passwordVerificationOtp}
                  onChange={(e) => setPasswordVerificationOtp(e.target.value)}
                  autoComplete="email"
                  style={{ boxSizing: 'border-box' }}
                />
                {errors.passwordVerificationOtp && <p className="error">{errors.passwordVerificationOtp}</p>}
              </div>
              <button className="btn" type="submit" disabled={loading} >
                Reset Password
              </button>
            </form>
          </div>
        </Card>
      )}
      <div>
        {setloading && (
          <div className="loading-overlay">
            <OrbitProgress variant="dotted" color="#8ABBF1" size="large" textColor="#000000" />
          </div>
        )}
      </div>
      <footer className="fixed bottom-0 left-0 right-0 h-12 bg-white border-t border-gray-200 flex items-center justify-center z-20">
        <span className="text-xs text-gray-500">
          ©{" "}
          <a
            href="https://cosmitude.com"
            target="_blank"
            rel="noopener noreferrer"

          >
            Cosmitude Softwares Private Limited. All rights reserved.
          </a>
        </span>
      </footer>
    </div>
  );

};

const emailLogin = (json) => {
  try {
    return axios({
      method: 'post',
      url: LLServerIP + 'emailLogin',
      data: json,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}
const loginWithGoogle = async (formData) => {
  try {
    return axios({
      method: 'post',
      url: LLServerIP + 'googleLogin',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}
export const emailAccountCreation = async (json) => {
  try {

    return axios({
      method: 'post',
      url: LLServerIP + 'emailAccountCreation',
      data: json,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}
export const emailAccountVerification = async (formData, serverip) => {
  try {
    return axios({
      method: 'post',
      url: serverip + 'emailAccountVerification',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}
export const emailAccountPasswordReset = async (json) => {
  try {
    return axios({
      method: 'post',
      url: LLServerIP + 'emailAccountPasswordReset',
      data: json,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}
export const userNewPasswordUpdate = async (json, serverip) => {
  try {
    return axios({
      method: 'post',
      url: serverip + 'userNewPasswordUpdate',
      data: json,
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  } catch (error) {
    console.error(error);
  }
}

